module.exports = __webpack_public_path__ + "media/companies/D_Angelin_Co-47661380.png";